export const ButtonsDisplayEnum = {
    RegistrationAndLogin: 0,
    OnlyRegistration: 1,
    OnlyLogin: 2,
    Join: 3
}
export const ButtonTypeEnum = {
    Standard: 0,
    StandardWithIcon: 1,
    OnlyIcon: 2,
    OnlyText: 3
}
